'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactRedux = require('react-redux');

var _recompose = require('recompose');

var _immutableHelper = require('../../../../../common/utils/immutableHelper');

var _navigationActions = require('../../../../reducers/navigationActions');

var _FullScreenErrorModal = require('../../../modal/FullScreenErrorModal');

var _FullScreenErrorModal2 = _interopRequireDefault(_FullScreenErrorModal);

var _ModalActionsList = require('../../../modal/ModalActionsList');

var _ModalActionsList2 = _interopRequireDefault(_ModalActionsList);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// Components


// Utils
// Lib
var mapStateToProps = function mapStateToProps(state, ownProps) {
    return {
        currentUser: state.getIn(['app', 'currentUser'])
    };
};

// Actions


var mapDispatchToProps = function mapDispatchToProps(dispatch, ownProps) {
    return {
        navigateToLogin: function navigateToLogin(event) {
            event.preventDefault();
            dispatch((0, _navigationActions.navigateToLogin)());
        }
    };
};

var BoardSimpleErrorModal = function BoardSimpleErrorModal(props) {
    var error = props.error,
        currentUser = props.currentUser,
        close = props.close;


    var isGuest = currentUser.get('isGuest');

    var guestActions = [{ text: 'Log in', func: props.navigateToLogin }];
    var loggedInActions = [];
    var actions = isGuest ? guestActions : loggedInActions;

    return _react2.default.createElement(
        _FullScreenErrorModal2.default,
        { overlay: true, close: close },
        _react2.default.createElement(
            'h2',
            null,
            (0, _immutableHelper.prop)('message', error)
        ),
        _react2.default.createElement(
            'div',
            null,
            _react2.default.createElement(
                'p',
                null,
                'Sorry, the board you\'re trying to access no longer exists.'
            ),
            _react2.default.createElement(_ModalActionsList2.default, { actions: actions })
        )
    );
};

BoardSimpleErrorModal.propTypes = {
    navigateToLogin: _propTypes2.default.func,
    error: _propTypes2.default.object,
    currentUser: _propTypes2.default.object,
    close: _propTypes2.default.func
};

var enhance = (0, _recompose.compose)((0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps));

exports.default = enhance(BoardSimpleErrorModal);


//////////////////
// WEBPACK FOOTER
// ./src/client/components/error/modals/components/BoardSimpleErrorModal.js
// module id = 1765
// module chunks = 0